const configuredSiteUrl = (process.env['NEXT_PUBLIC_SITE_URL'] || '').replace(/\/$/, '');

type RequestHeaders = { host?: string; 'x-forwarded-proto'?: string | string[] };

// NEXT_PUBLIC_SITE_URL is the canonical origin. Falling back to the request's own host keeps local
// dev and deploy previews working, since a sitemap can't use relative urls. Pass no headers to get
// the configured origin only (an empty string when it isn't set).
export const getSiteOrigin = (headers?: RequestHeaders) => {
    if (configuredSiteUrl) return configuredSiteUrl;
    if (!headers?.host) return '';

    const forwarded = headers['x-forwarded-proto'];
    // netlify/cloudflare can send a comma separated list
    const proto = (Array.isArray(forwarded) ? forwarded[0] : forwarded)?.split(',')[0]?.trim() || 'http';

    return `${proto}://${headers.host}`;
};

export default getSiteOrigin;
